import Swal from "sweetalert2";
import { apiV2, errorHandler } from "./index";
import { API_ERROR, DELETE_MARKETING_INITIATIVE, DELETE_MARKETING_INITIATIVE_ERROR, DELETE_MARKETING_INITIATIVE_SUCCESS, ENABLE_DISABLE_MARKETING_INITIATIVE, ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR, ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS, FETCH_ALL_MARKETING_INITIATIVES, FETCH_ALL_MARKETING_INITIATIVES_ERROR, FETCH_ALL_MARKETING_INITIATIVES_SUCCESS, SAVE_MARKETING_INITIATIVE, SAVE_MARKETING_INITIATIVE_ERROR, SAVE_MARKETING_INITIATIVE_SUCCESS } from "../constants/ActionTypes";

export function fetchAllMarketingInitiatives() {
    return function (dispatch) {
        dispatch({ type: FETCH_ALL_MARKETING_INITIATIVES });

        apiV2.get('/marketing-initiatives')
            .then((response) => {
                dispatch({
                    type: FETCH_ALL_MARKETING_INITIATIVES_SUCCESS,
                    payload: response.data.objects || response.data || []
                });
            })
            .catch((error) => {
                dispatch({ type: FETCH_ALL_MARKETING_INITIATIVES_ERROR, payload: [] });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function createMarketingInitiative(data, onSuccess) {
    return function (dispatch) {
        dispatch({ type: SAVE_MARKETING_INITIATIVE });

        apiV2.post('/marketing-initiatives', {
            name: data.name,
            code: data.code,
            description: data.description,
            default_unlock_duration: data.default_unlock_duration,
            global_campaign_lifespan: data.global_campaign_lifespan,
            resources: data.resources,
        })
            .then((response) => {
                dispatch({ type: SAVE_MARKETING_INITIATIVE_SUCCESS, payload: response.data });
                Swal.fire({
                    icon: "success",
                    title: "Marketing Initiative Saved!",
                    timer: 1000
                }).then(() => {
                    onSuccess?.();
                })
            })
            .catch((error) => {
                dispatch({ type: SAVE_MARKETING_INITIATIVE_ERROR, payload: error });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function updateMarketingInitiative(id, data, onSuccess) {
    return function (dispatch) {
        dispatch({ type: SAVE_MARKETING_INITIATIVE });

        apiV2.put(`/marketing-initiatives/${id}`, {
            name: data.name,
            code: data.code,
            description: data.description,
            default_unlock_duration: data.default_unlock_duration,
            global_campaign_lifespan: data.global_campaign_lifespan,
            resources: data.resources,
        })
            .then((response) => {
                dispatch({ type: SAVE_MARKETING_INITIATIVE_SUCCESS, payload: response.data });
                Swal.fire({
                    icon: "success",
                    title: "Marketing Initiative Saved!",
                    timer: 1000
                }).then(() => {
                    onSuccess?.();
                })
            })
            .catch((error) => {
                dispatch({ type: SAVE_MARKETING_INITIATIVE_ERROR, payload: error });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function deleteMarketingInitiative(id) {
    return function (dispatch) {
        dispatch({ type: DELETE_MARKETING_INITIATIVE, payload: id });

        apiV2.delete(`/marketing-initiatives/${id}`)
            .then((response) => {
                dispatch({
                    type: DELETE_MARKETING_INITIATIVE_SUCCESS, payload: id
                });
                Swal.fire({
                    icon: "success",
                    title: "Marketing Initiative Deleted!",
                    timer: 2000
                });
            })
            .catch((error) => {
                dispatch({ type: DELETE_MARKETING_INITIATIVE_ERROR, payload: error });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function enableDisableMarketingInitiative(id, is_active) {
    return function (dispatch) {
        dispatch({ type: ENABLE_DISABLE_MARKETING_INITIATIVE, payload: id });

        apiV2.put(`/marketing-initiatives/${id}/enabled-disabled`, { is_active })
            .then((response) => {
                dispatch({ type: ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS, payload: {
                    id,
                    is_active
                } });
            })
            .catch((error) => {
                dispatch({ type: ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR, payload: error });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

